// as an exception, somehow we have to handle those promises

import type { CLSMetric, FCPMetric, INPMetric, LCPMetric, TTFBMetric } from 'web-vitals';

type ReportHandler = (metric: INPMetric | CLSMetric | INPMetric | LCPMetric | FCPMetric | TTFBMetric) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler): void => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    void import('web-vitals').then(({
      onCLS,
      onINP,
      onFCP,
      onLCP,
      onTTFB,
    }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
